import { FormikProps, getIn } from 'formik';
import React from 'react';
import styled from 'styled-components/macro';
import { spacing04 } from '../../styling/spacing';
import { Alert } from '../Alert';

type Props<TFormModel> = {
  topLevelValidationFieldName: string;
  formErrors: FormikProps<TFormModel>['errors'];
};

export const topLevelValidationErrorTestId = 'top-level-validation-error';

export const TopLevelValidationError = <TFormModel,>({
  topLevelValidationFieldName,
  formErrors,
}: Props<TFormModel>) => {
  const topLevelValidationError = getIn(formErrors, topLevelValidationFieldName);
  return (
    <TopLevelValidationErrorContainer>
      {topLevelValidationError ? (
        <Alert data-testid={topLevelValidationErrorTestId} type="warning" body={topLevelValidationError} />
      ) : null}
    </TopLevelValidationErrorContainer>
  );
};

export const TopLevelValidationErrorContainer = styled.div`
  &:not(:empty) {
    margin-top: ${spacing04};
  }
`;
